import React, { useState } from "react";
import { Box } from "@material-ui/core";
import AppFilterChipComponent from "../../../components/form/app-filter-chip";

const FilterChipsComponent = () => {
  const [selectedFilterChip, setSelectedFilterChip] = useState<string>("");

  const handleSelectFilterChip = (filterChip: string) => {
    setSelectedFilterChip(filterChip);
  };

  return (
    <Box style={{ display: "grid", gap: "1.5rem", padding: "0 40px" }}>
      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <AppFilterChipComponent
          label="Small FilterChip"
          size="small"
          selected={selectedFilterChip === "small"}
          onClick={() => handleSelectFilterChip("small")}
        />
        <AppFilterChipComponent
          label="Medium FilterChip"
          size="medium"
          selected={selectedFilterChip === "medium"}
          onClick={() => handleSelectFilterChip("medium")}
        />
        <AppFilterChipComponent
          label="Large FilterChip"
          size="large"
          selected={selectedFilterChip === "large"}
          onClick={() => handleSelectFilterChip("large")}
        />
      </Box>

      <Box
        className="d-flex align-items-center flex-wrap"
        style={{ gap: "1.5rem" }}
      >
        <AppFilterChipComponent
          label="Primary FilterChip"
          size="medium"
          selected={selectedFilterChip === "primary-chip"}
          color="primary"
          onClick={() => handleSelectFilterChip("primary-chip")}
        />
        <AppFilterChipComponent
          label="Secondary FilterChip"
          size="medium"
          selected={selectedFilterChip === "secondary-chip"}
          color="secondary"
          onClick={() => handleSelectFilterChip("secondary-chip")}
        />
      </Box>
    </Box>
  );
};

export default FilterChipsComponent;
